// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NA4_TheComp__3XxcU"};